import {
    takeEvery, put, call, select,
} from 'redux-saga/effects';
import { showMessage, startLoading, stopLoading } from '../../../theme/constants/actionConstants';
import * as actions from '../constants/actionConstants';
import {ORDER_CHECK_PRICE_GET} from '../constants/actionTypes';
import myAxios from '../../../constants/myAxios';
import {getCheckPriceDocFail, getCheckPriceDocSuccess} from "../constants/actionConstants";

export function* checkPriceWatcher() {
    yield takeEvery(ORDER_CHECK_PRICE_GET, checkPriceWorker);
}

function* checkPriceWorker(action) {
    yield put(startLoading());
    try {
        const payload = yield call(myAxios, `/orders/checkprice/${action.orderType}`, 'get',action.params);
        if ( payload.data === null ){
            yield put(actions.getCheckPriceDocSuccess([]));
        } else {
            yield put(actions.getCheckPriceDocSuccess( payload.data.data));
        }
        yield put(stopLoading());
    } catch (error) {
        let message = '';
        error.response && error.response.status >= 500 ? message = 'Server error' : message = 'Invalid credantials';
        yield put(actions.getCheckPriceDocFail( error.response));
        yield put(showMessage({
            message,
            variant: 'error',
        }));
        yield put(stopLoading());
    }
}